import { Pipe, PipeTransform } from '@angular/core';
import { ShoppingCartItem } from '@app/store/shopping-cart';

@Pipe({
    name: 'total',
})
export class PriceTotalPipe implements PipeTransform {
    transform(cartItems: ShoppingCartItem[] | null): number | null {
        return (
            cartItems?.reduce((total, { qtyPerUnit, product, qty }) => {
                const value = qtyPerUnit ? product.defaultDiscountPrice * qtyPerUnit * qty : 0;

                return total + value;
            }, 0) ?? null
        );
    }
}
